import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'

export default class CustomFieldsDescriptionStrategy extends DescriptionStrategy {
    constructor({ reportUrl = '' }) {
        super()
        this.params = { reportUrl }
    }

    getHeader() {
        return messageResource.getMessage('report.custom_fields.title')
    }

    getDescription() {
        const firstParagraph = messageResource.getEscapedMessage('dashboard.description.custom_fields.part1')
        const secondParagraph = messageResource.getEscapedMessage('dashboard.description.custom_fields.part2')
        return this._createDescription(firstParagraph, secondParagraph)
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }

    getDetailsCallback() {
        openUserGuidePage('custom-fields-report', 'reporting#custom-fields-report')
    }

    _createDescription(first, second) {
        return '<div>' +
               '  <div class="firstParagraph customFieldsDescriptionColor">' + first + '</div>' +
               '  <div class="secondParagraph">' + second + '</div>' +
               '</div>'
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/CustomFieldsDescriptionStrategy.js